var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMoveUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#3B66B0;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M21,3.6v2.2h-3l0.4,0.4C19.3,7,19.9,8,20.4,9c0.4,1,0.6,2.1,0.6,3.2c0,2-0.6,3.8-1.8,5.3 c-1.2,1.6-2.8,2.6-4.7,3.1v-2.3c1.3-0.5,2.3-1.3,3.1-2.4s1.2-2.4,1.2-3.8c0-0.8-0.2-1.6-0.5-2.4c-0.3-0.8-0.8-1.5-1.4-2.1l-0.3-0.3 v2.7h-2.2V3.6H21z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M9.2,5.6v3.9H5.3V5.6H9.2 M11.2,3.6H3.3v7.9h7.9V3.6L11.2,3.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M9.2,14.8v3.9H5.3v-3.9H9.2 M11.2,12.8H3.3v7.9h7.9V12.8L11.2,12.8z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoveUp);
export default __webpack_public_path__ + "static/media/move-up.b6f4a2511e9a3fdcb0cd91b7b8a302d4.svg";
export { ForwardRef as ReactComponent };